import { pageCells, cellStyle } from "../pageGeometry.js";

export default function PageMiniPreview({ layout, photos, empty = false, side = "left",
  pagesCount = 0, pageWidthMm = 155, pageHeightMm = 210 }) {
  const cells = empty ? [] : pageCells(layout, side, pageWidthMm, pageHeightMm, pagesCount);
  return <div style={{ position: "relative", width: "100%", height: "100%",
    overflow: "hidden", background: layout?.framed ? "#fff" : "#f4f4f7" }}>
    {cells.map((cell, index) => {
      const photo = photos?.[index];
      return <div key={index} data-page-cell={index} style={{ ...cellStyle(cell),
        overflow: "hidden", background: "#efefef" }}>
        {photo?.url && <img src={photo.url} alt="" draggable={false} style={{
          width: "100%", height: "100%", display: "block",
          objectFit: photo.fit || "cover", objectPosition: photo.position || "center",
        }} />}
      </div>;
    })}
  </div>;
}